import initialState from "../initialState";

import { SESSION_ACTIONS } from "./actions";

const mstrSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_ACTIONS.SET_TOKEN:
      return {
        ...state,
        token: action.payload.token,
        groups: action.payload.groups,
      };
    case SESSION_ACTIONS.CLEAR_TOKEN:
      return {
        ...state,
        token: null,
      };
    default:
      return state;
  }
};

export default mstrSessionReducer;
